import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Table } from '~/components/blocks';
import { settingsDrawerState } from '~/state/settings_systemsettings/atoms';

export const NotificationSetting = () => {
  const set = useSetAtom(settingsDrawerState);

  const handleClick = useCallback(() => {
    set({ drawer: 'notificationSetting' });
  }, [set]);

  return (
    <>
      <Table.Tr onClick={handleClick}>
        <Table.Td>通知設定</Table.Td>
      </Table.Tr>
    </>
  );
};
